
import { defineComponent } from 'vue';
import ClickOutside from '@/util/directives/ClickOutside';

export default defineComponent({
    emits: ['update:values'],
    directives: { ClickOutside },
    props: {
        label: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: [],
        },
        values: {
            type: Array,
            required: true,
        },
        itemText: {
            type: String,
            required: true,
        },
        itemValue: {
            type: String,
            required: true,
        },
        selectAllValue: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            expandDropdown: false,
        };
    },
    computed: {
        computedLabel(): string {
            switch (this.$props.values.length) {
                case 0: {
                    return this.$props.label;
                }
                case 1: {
                    return (this.$props.values[0] as any)[this.$props.itemText];
                }
                default: {
                    return `${this.$props.values.length} valgt`;
                }
            }
        },
    },
    methods: {
        onSelectClicked() {
            this.expandDropdown = !this.expandDropdown;
        },
        onItemClicked(item: { [key: string]: any }) {
            if (item[this.$props.itemValue] === this.$props.selectAllValue) {
                this.$emit('update:values', []);
                return;
            }
            const newValue = [...this.$props.values];
            const itemSelectedIndex = newValue.findIndex((currentValue: any) => currentValue[this.$props.itemValue] === item[this.$props.itemValue]);
            if (itemSelectedIndex === -1) {
                newValue.push(item);
                this.$emit('update:values', newValue);
            } else {
                newValue.splice(itemSelectedIndex, 1);
                this.$emit('update:values', newValue);
            }
        },
    },
});
